import isAgentUser from './isAgentUser'
import isCacheDisabled from './isCacheDisabled'

export default {
  agentUser: isAgentUser,
  cacheDisabled: isCacheDisabled
}
